export const UPDATE_SUCCESS = 'Organization successfully updated';
export const UPDATE_DENIED = 'You can not update this organization';
